// cleanup_convert_to_typescript_file_GENERICS

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Typography, { variants, weights } from 'components/typography/Typography';

import { LABEL, LINK_ADD_WIDGET, LINK_INITIATE } from './ListPill.constants';
import useStyles from './listPill.styles';

export const ListPillCustomLinkComponent = ({ linkRole, onChange, params }) => {
  const { linkLabel, linkTitle } = useStyles();
  const { name, path, state, value } = params.option;
  const onCustomClick = params.onClick;
  const link = params.option;
  if ([LINK_ADD_WIDGET, LINK_INITIATE].includes(link.name)) return null;

  const props = {
    key: name
  };

  const isLinkType = path;
  const isLabel = link.type && link.type === LABEL;

  const buttonsProps = {
    ...props,
    onClick: () => {
      onCustomClick(value); // Need to trigger the onClick from the dropdown to close it
      onChange(value);
    },
    to: {},
    value
  };
  const linksProps = {
    ...props,

    to: {
      pathname: link.path,
      state,
      ...(link.state ? { state: { ...state, ...link.state } } : [])
    }
  };
  return isLabel ? (
    <Typography variant={variants.smallLabel} weight={weights.medium} className={linkLabel}>
      {name}
    </Typography>
  ) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Link {...(!isLinkType ? buttonsProps : linksProps)} data-qa={link.dataQa} role={linkRole}>
      <Typography variant={variants.linkTitle} className={linkTitle}>
        {name}
      </Typography>
    </Link>
  );
};

ListPillCustomLinkComponent.propTypes = {
  onChange: PropTypes.func,
  params: PropTypes.shape({
    onClick: PropTypes.func,
    option: PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
      permission: PropTypes.shape([]),
      state: PropTypes.shape({}),
      type: PropTypes.string,
      value: PropTypes.string,
      dataQa: PropTypes.string
    })
  }).isRequired,
  show: PropTypes.bool,
  state: PropTypes.shape({}).isRequired,
  linkRole: PropTypes.string
};

ListPillCustomLinkComponent.defaultProps = {
  onChange: () => {},
  show: false,
  linkRole: undefined
};

export default ListPillCustomLinkComponent;
